export default (sharedState, key) => {
    return sharedState ? ( sharedState[key] ? sharedState[key] : '' ) : '';
};